import React from 'react';
import {Route} from 'react-router-dom';
import {WithPermission} from 'admin-on-rest';

import LocationDashboard from './Fuse/Location/dashboard';

import ProductDashboard from './Fuse/Product/dashboard';
import {
    fuseProductShow as FuseProductShow,
    fuseProductEdit as FuseProductEdit
} from './Fuse/Product/product';
import {
    fuseProductUnitShow as FuseProductUnitShow,
    fuseProductUnitCreate as FuseProductUnitCreate,
    fuseProductUnitEdit as FuseProductUnitEdit
} from './Fuse/Product/productUnit';
import {
    fuseProductCategoryShow as FuseProductCategoryShow,
    fuseProductCategoryEdit as FuseProductCategoryEdit
} from './Fuse/Product/category';
import {
    fuseDiscountShow as FuseDiscountShow,
    fuseDiscountEdit as FuseDiscountEdit
} from './Fuse/Product/discount';
import {
    fuseProductAliasShow as FuseProductAliasShow,
    fuseProductAliasEdit as FuseProductAliasEdit
} from './Fuse/Product/alias';

import InventoryDashboard from './Fuse/Inventory/dashboard';
import {
    fuseLocationInventoryEdit as FuseLocationInventoryEdit,
    fuseLocationInventoryZeroOut as FuseLocationInventoryZeroOut
} from './Fuse/Inventory/locationInventory';
import {IncomingTransferList} from './Fuse/Inventory/IncomingTransferList';
import {ReceivedTransferList} from './Fuse/Inventory/ReceivedTransferList';
import {TransfersByMemoList} from './Fuse/Inventory/TransfersByMemoList';
import {
    fuseIncomingTransferShow as FuseIncomingTransferShow,
    fuseIncomingTransferShowViewOnly as FuseIncomingTransferShowViewOnly,
    fuseReceivedTransferShow as FuseReceivedTransferShow,
    fuseTransferByMemoShow as FuseTransferByMemoShow
} from './Fuse/Inventory/transfer';
import {fuseLocationAuditShow as FuseLocationAuditShow} from './Fuse/Inventory/locationAudit';
import {MissingScansList} from './Fuse/Inventory/MissingScansList';
import {LocationInventoryLevels} from './Fuse/Inventory/LocationInventoryLevels';
import {RepacksRetailBoxes} from './Fuse/Inventory/RepacksRetailBoxes';
import {
    fuseRepackRetailBoxShow as FuseRepackRetailBoxShow
} from './Fuse/Inventory/repackRetailBox';
import {TransferredProductsList} from './Fuse/Inventory/TransferredProductsList';

import LoyaltyDashboard from './Fuse/Loyalty/dashboard';

import PosKitDashboard from './Fuse/Kit/dashboard';

import PosUserDashboard from './Fuse/User/posUserDashboard';

import ConfigurationDashboard from './Fuse/Setting/dashboard';
import {
    fuseSetMode as FuseSetMode
} from './Fuse/Setting/setMode';

import HelpDashboard from './Fuse/Help';

const customRoutes = [
    <Route exact path="/Location" component={LocationDashboard}/>,

    <Route exact path="/Product" component={ProductDashboard}/>,

    <Route exact path="/Products/:type/:id/show" render={(routeProps) =>
        [
            <WithPermission key="product-show"
                            value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
                <FuseProductShow resource="Products" canEdit={true} hasList hasEdit {...routeProps} />
            </WithPermission>,
            <WithPermission key="product-show-view-only" value={['products_vo']}>
                <FuseProductShow resource="Products" canEdit={false} hasList hasEdit {...routeProps} />
            </WithPermission>
        ]
    }/>,
    <Route exact path="/Products/:type/:id" render={(routeProps) =>
        <WithPermission value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
            <FuseProductEdit resource="Products" hasList hasShow {...routeProps} />
        </WithPermission>
    }/>,

    <Route exact path="/ProductUnits/:type/:id/show" render={(routeProps) =>
        [
            <WithPermission key="product-unit-show"
                            value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
                <FuseProductUnitShow resource="ProductUnits" canEdit={true} hasEdit {...routeProps} />
            </WithPermission>,
            <WithPermission key="product-unit-show-view-only"
                            value={['products_vo']}>
                <FuseProductUnitShow resource="ProductUnits" canEdit={false} hasEdit {...routeProps} />
            </WithPermission>
        ]
    }/>,
    <Route exact path="/ProductUnits/:type/:id/create" render={(routeProps) =>
        <WithPermission value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
            <FuseProductUnitCreate resource="ProductUnitCreate" {...routeProps} />
        </WithPermission>
    }/>,
    <Route exact path="/ProductUnits/:type/:id" render={(routeProps) =>
        <WithPermission value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
            <FuseProductUnitEdit resource="ProductUnits" hasShow {...routeProps} />
        </WithPermission>
    }/>,

    <Route exact path="/ProductCategories/:type/:id/show" render={(routeProps) =>
        [
            <WithPermission key="product-category-show"
                            value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
                <FuseProductCategoryShow resource="ProductCategories" canEdit={true} {...routeProps} />
            </WithPermission>,
            <WithPermission key="product-category-show-view-only" value={['products_vo']}>
                <FuseProductCategoryShow resource="ProductCategories" canEdit={false} {...routeProps} />
            </WithPermission>
        ]
    }/>,
    <Route exact path="/ProductCategories/:type/:id" render={(routeProps) =>
        <WithPermission value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
            <FuseProductCategoryEdit resource="ProductCategories" hasList hasShow {...routeProps} />
        </WithPermission>
    }/>,

    <Route exact path="/Discounts/:type/:id/show" render={(routeProps) =>
        [
            <WithPermission key="product-discount-show"
                            value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
                <FuseDiscountShow resource="Discounts" canEdit={true} hasList hasEdit {...routeProps} />
            </WithPermission>,
            <WithPermission key="product-discount-show-view-only"
                            value={['products_vo']}>
                <FuseDiscountShow resource="Discounts" canEdit={false} hasList hasEdit {...routeProps} />
            </WithPermission>
        ]
    }/>,
    <Route exact path="/Discounts/:type/:id" render={(routeProps) =>
        <WithPermission value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
            <FuseDiscountEdit resource="Discounts" hasList hasShow {...routeProps} />
        </WithPermission>
    }/>,

    <Route exact path="/ProductAliases/:type/:id/show" render={(routeProps) =>
        [
            <WithPermission key="product-alias-show"
                            value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
                <FuseProductAliasShow resource="ProductAliases" canEdit={true} hasList hasEdit {...routeProps} />
            </WithPermission>,
            <WithPermission key="product-alias-show-view-only"
                            value={['products_vo']}>
                <FuseProductAliasShow resource="ProductAliases" canEdit={false} hasList hasEdit {...routeProps} />
            </WithPermission>
        ]
    }/>,
    <Route exact path="/ProductAliases/:type/:id" render={(routeProps) =>
        <WithPermission value={['sys_op', 'sections_all', 'admin', 'products_all', 'products_np']}>
            <FuseProductAliasEdit resource="ProductAliases" hasList hasShow {...routeProps} />
        </WithPermission>}
    />,

    <Route exact path="/Inventory" component={InventoryDashboard}/>,
    <Route exact path="/LocationInventory/:location_id/:id" render={(routeProps) =>
        <WithPermission value={['sys_op', 'sections_all', 'admin', 'inventory']}>
            <FuseLocationInventoryEdit resource="LocationInventory" hasList {...routeProps} />
        </WithPermission>
    }/>,
    <Route exact path="/ZeroOutLocationInventory/:location_id" render={(routeProps) =>
        <WithPermission value={['sys_op', 'sections_all', 'admin', 'inventory']}>
            <FuseLocationInventoryZeroOut resource="LocationInventory" hasList {...routeProps} />
        </WithPermission>
    }/>,

    <Route exact path="/InventoryTransfers/memo/:transfer_id/show" render={(routeProps) =>
        [
            <WithPermission key="inventory-memo-show" value={['sys_op', 'sections_all', 'admin', 'inventory']}>
                <FuseTransferByMemoShow resource="InventoryTransferContents" hasList {...routeProps} />
            </WithPermission>,
            <WithPermission key="inventory-memo-show-view-only" value={['inventory_vo']}>
                <FuseTransferByMemoShow resource="InventoryTransferContents" hasList {...routeProps} />
            </WithPermission>
        ]
    }/>,
    <Route exact path="/InventoryTransfers/incoming/:location_id/:transfer_id/show" render={(routeProps) =>
        [
            <WithPermission key="inventory-incoming-show" value={['sys_op', 'sections_all', 'admin', 'inventory']}>
                <FuseIncomingTransferShow resource="InventoryTransferContents" hasList {...routeProps} />
            </WithPermission>,
            <WithPermission key="inventory-incoming-show-view-only" value={['inventory_vo']}>
                <FuseIncomingTransferShowViewOnly resource="InventoryTransferContents" hasList {...routeProps} />
            </WithPermission>
        ]
    }/>,
    <Route exact path="/InventoryTransfers/received/:location_id/:transfer_id/show" render={(routeProps) =>
        [
            <WithPermission key="inventory-received-show" value={['sys_op', 'sections_all', 'admin', 'inventory']}>
                <FuseReceivedTransferShow resource="InventoryTransferContents" hasList {...routeProps} />
            </WithPermission>,
            <WithPermission key="inventory-received-show-view-only" value={['inventory_vo']}>
                <FuseReceivedTransferShow resource="InventoryTransferContents" hasList {...routeProps} />
            </WithPermission>
        ]
    }/>,
    <Route exact path="/InventoryTransfers" component={IncomingTransferList}/>,
    <Route exact path="/InventoryTransfersByMemo" component={TransfersByMemoList}/>,
    <Route exact path="/LocationInventoryLevels" component={LocationInventoryLevels}/>,
    <Route exact path="/InventoryRepacksRetailBoxes" component={RepacksRetailBoxes}/>,
    <Route exact path="/InventoryRepacksRetailBoxes/:id/show" render={(routeProps) =>
        [
            <WithPermission key="repacks-retail-boxes-show"
                            value={['sys_op', 'sections_all', 'admin', 'inventory', 'inventory_vo']}>
                <FuseRepackRetailBoxShow resource="InventoryRepacksRetailBoxes" canEdit={true} {...routeProps} />
            </WithPermission>,
            <WithPermission key="repacks-retail-boxes-show-view-only" value={['inventory_vo']}>
                <FuseRepackRetailBoxShow resource="InventoryRepacksRetailBoxes" canEdit={false} {...routeProps} />
            </WithPermission>
        ]
    }/>,

    <Route exact path="/TransferredProducts" component={TransferredProductsList}/>,
    <Route exact path="/MissingScans" render={(routeProps) =>
        [
            <WithPermission key="location-audit-show" value={['sys_op', 'sections_all', 'admin', 'inventory', 'inventory_vo']}>
                <MissingScansList/>
            </WithPermission>
        ]
    }/>,
    <Route exact path="/ReceivedInventoryTransfers" component={ReceivedTransferList}/>,

    <Route exact path="/LocationAudits/:location_id/:audit_uuid/show" render={(routeProps) =>
        [
            <WithPermission key="location-audit-show" value={['sys_op', 'sections_all', 'admin', 'inventory']}>
                <FuseLocationAuditShow resource="LocationAudits" hasList {...routeProps} canEdit={true}/>
            </WithPermission>,
            <WithPermission key="location-audit-show-view-only" value={['inventory_vo']}>
                <FuseLocationAuditShow resource="LocationAudits" hasList {...routeProps} canEdit={false}/>
            </WithPermission>
        ]
    }/>,

    <Route exact path="/Loyalty" component={LoyaltyDashboard}/>,

    <Route exact path="/POSKit" component={PosKitDashboard}/>,

    <Route exact path="/POSUser" component={PosUserDashboard}/>,

    <Route exact path="/Configuration" component={ConfigurationDashboard}/>,
    <Route exact path="/Configuration/Mode" render={(routeProps =>
            <WithPermission value={['sys_op', 'sections_all', 'admin', 'configuration']}>
                <FuseSetMode {...routeProps}/>
            </WithPermission>
    )}/>,

    <Route exact path="/Help" component={HelpDashboard}/>
];

export default customRoutes;



// WEBPACK FOOTER //
// ./src/routes.js